import type { PersonDeceasedCommandData } from '@festina/legalentity-general-types/legalentity'
import { typeUtils } from '@festina-life/core'
import {
  FormikDatePicker,
  FormikForm,
  FormikSelect,
} from '@festina-life/ui/formikForms'
import { useTranslate, useTranslateEnum } from '@festina-life/ui/hooks'

import { useHook } from '../../lenteHooks'
import type { CommandDataFormProps } from '../commandActions/CommandDataFormAndSimulation'

const validateKey = typeUtils.createValidator<PersonDeceasedCommandData>()

export const PersonDeceasedCommandDataForm = (
  props: CommandDataFormProps<PersonDeceasedCommandData>,
) => {
  const translate = useTranslate()
  const translateEnum = useTranslateEnum()

  const informationSources = useHook('pages.crm.useCrmInformationSources')()

  return (
    <FormikForm
      initialValues={{
        _type: 'PersonDeceasedCommandData',
      }}
      {...props}
    >
      <FormikDatePicker
        name={validateKey('deathDate')}
        label={translate('deathButton.deathDate')}
      />
      <FormikSelect
        name={validateKey('informationSource')}
        label={translate('card.field.informationSource')}
        options={informationSources}
        renderFn={(x) => translateEnum('legalEntity.enum.InformationSource', x)}
      />
    </FormikForm>
  )
}
